const allowCreate = [1, 2, 4];

function canWorkspaceCreate(userRoles) {
  return userRoles?.some(role => allowCreate.includes(role));
}

export {
  canWorkspaceCreate
};